export default {
      id: "icon-web-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-web",
      toString: function () {
        return this.url;
      }
    }